import { createContext, useContext, useState, useEffect } from 'react'
import { useRouter } from 'next/router'

const SearchModalContext = createContext()

export function useSearchModalContext() {
  return useContext(SearchModalContext)
}

export function SearchProvider({ children, searchLinks }) {
  const [searchOpen, setSearchOpen] = useState(false)
  const router = useRouter()

  useEffect(() => {
    if (searchOpen) document.querySelector('html').classList.add('disable-scroll')
    if (!searchOpen) document.querySelector('html').classList.remove('disable-scroll')

  }, [searchOpen])

  useEffect(() => {
    const onRountChangeComplete = () => {
      setSearchOpen(false)
    }
    router.events.on('routeChangeComplete', onRountChangeComplete)
  }, [router.pathname])

  return (
    <SearchModalContext.Provider value={{ searchOpen, setSearchOpen, searchLinks }}>
      {children}
    </SearchModalContext.Provider>
  )
}